module.exports = __webpack_public_path__ + "static/img/Send5.e717351.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Send5.png
// module id = 1fA/
// module chunks = 0